import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  offices: null,
  selectedOffice: "",
  showAdvancedFilter: false,
  selectedUsers: [],
  selectedEntitlements: [],
  isPossibleToContinue: false,
  loaderListEntitlements: false,
  listEntitlements: null,
  totalEntitlements: [],
  addedEntitlements: [],
  deletedEntitlements: [],
  modifiedEntitlements: [],
  prevEntitlements: [],
  chainEntitlements: [],
  showfilterModal: false,
  globalCatalog: null,
  callState: IResponseState.SUCCESS,
};
